import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContactModule} from './contact/contact.module';
import {CompanyModule} from './company/company.module';
import {InvoiceModule} from './invoice/invoice.module';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ContactModule,
        CompanyModule,
        InvoiceModule
    ],
    exports: [ContactModule, CompanyModule, InvoiceModule]
})
export class InvoicingModule { }
